









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Position, WidgetType } from '@/models/Enums';

@Component
export default class WidgetTitle extends Vue {
  @Prop() private type!: WidgetType;
  @Prop() private small!: Position;
  @Prop() private multiple!: boolean;
  @Prop() private lite!: boolean;

  private title = '';
  private link = '';
  private logo = '';
  private created() {
    this.SetText();
  }
  private get isDe() {
    return (window as any).dkVars.isDe;
  }
  private get showLogos() {
    return !this.isDe && this.small === Position.Center && this.link.length > 0 && this.logo.length > 0;
  }
  private SetText() {
    if (this.lite) {
      this.title = 'Fotofachhändler in Ihrer Nähe';
      return;
    }
    let shopName: string = '';
    switch (this.type) {
      case WidgetType.Amazon:
        shopName = 'bei Amazon';
        this.logo = 'https://www.digitalkamera.de/App_Themes/dk/img/amazon-logo-tiny.gif';
        this.link = 'http://www.amazon.de/?tag=digitalkamera_de-21';
        break;
      case WidgetType.Dk:
        shopName = 'im digitalkamera.de-Shop';
        break;
      case WidgetType.Idealo:
        shopName = 'im Preisvergleich';
        this.logo = 'https://images.digitalkamera.de/Logos/Idealo-100x020-weiss.png';
        this.link =
          'http://www.idealo.de/preisvergleich/ProductCategory/1362.html?utm_medium=' +
          'affiliate&utm_source=koop&utm_campaign=dikamera&utm_content=feed_pv&camp=dikamera';
        break;
      case WidgetType.LocalShop:
        shopName = 'bei lokalen Händlern';
    }
    const firstPart = this.multiple ? 'Diese Produkte' : 'Dieses Produkt';
    this.title = `${firstPart} ${shopName}`;
  }
}
